import styled from 'styled-components';
export const FooterQuestionsStyled = styled.div`
  width: 100%;
  .questionBox {
    width: 100%;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    .question {
      color: ${(props) => props?.theme?.text?.darkest};
      font-size: 17px;
      font-weight: 700;
      line-height: 21px;
    }
    .answer {
      color: ${(props) => props?.theme?.text?.darkest};
      font-size: 13px;
      font-weight: 400;
      line-height: 22px;
      word-break: break-all;
      a {
        color: ${(props) => props?.theme?.blue?.dark};
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;
